// extracted by mini-css-extract-plugin
export default {"container":"ImageCarousel_container__bJClB","imageCarousel":"ImageCarousel_imageCarousel__BtWIo","thumbnail":"ImageCarousel_thumbnail__7Yc7B"};